import type React from 'react';

function GardenstoreIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 70.66 70.66"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Gardenstore Icon</title>

      <g id="Lager_1-2" data-name="Lager 1">
        <path
          d="M49.04,44.86q-10.6-1.6-9-10.1c5.2,0,10.6-.2,16,.2,.9,0,2.4,2.1,2.4,3.3,.2,5.9,.2,11.9,0,17.8-.1,1.4-.8,2.7-2,3.5-22.1,11.4-43.6,1.7-48.8-17.6-3.2-12.3,1.6-25.4,12.2-32.6,10.9-7.1,25-6.8,35.5,.7,4.6,3.3,1.2,5-.8,7.2-.7,.7-1.5,1.4-2.2,2.1-4.9-1.7-9.1-3.9-13.5-4.4-8.2-1-15.4,3.7-18.7,11.2-3.3,7.3-1.8,15.8,3.7,21.6,5.4,5.7,14.6,7.9,21.5,4.5,1.8-1,2.3-4.5,3.7-7.4Z"
          fill="inherit"
        />
        <rect width="70.66" height="70.66" fill="none" />
      </g>
    </svg>
  );
}

export default GardenstoreIcon;
